<template>
<div>
    
    <div v-if="entries && entries.length" class="">
        <div :class="`${cssClass ? cssClass : 'section mb10'} ${OpenHistory(log, true) ? 'selectable' : ''}`"
        v-for="(log, index) in entries"
        :key="index"
        @click="OpenHistory(log)">
            <div class="flex fill align-center">
                <!--<img v-show="desktop" height="35" :src="LogIcon(log.type)" class="mr15">-->
                <avatar class="mr10"
                :icon="Util.LogTypes[log.type] ? Util.LogTypes[log.type].icon : 'circle-exclamation'"
                :secondaryIcon="Util.LogTypes[log.type] ? Util.LogTypes[log.type].secondary : ''"
                :color="Util.LogTypes[log.type] ? Util.LogTypes[log.type].color : ''">
                </avatar>

                <div class="flex column flex-fill">
                    <div class="bold">{{Util.Date(log.date, 'LLLL')}}</div>
                    <div class="secondary-text">{{log.title}}</div>
                </div>
                <!--<i v-if="logTypes[log.type] && log.id_reference" class="icon icon-arrow-right"></i>-->
            </div>
        </div>
    </div>
    <div class="secondary-text ta-center mt10" v-else>No hay datos.</div>

    <modal v-model="modalTransactionEdit" :dir="['right', 'right']" :modalClass="['fill', 'right xl h100']" :title="`Detalles`" hideActions>
        <div slot="options">
            <button id="button-collapse" type="button" class="button-collapse secondary" data-action="toggle">Mostrar/Ocultar todo</button>
        </div>
        <div class="pa-body">
            <div v-if="modalTransactionEdit" v-html="modalTransactionEdit"></div>
        </div>
	</modal>

    <transaction-details ref="transactionDetails"></transaction-details>
    <transactions-list ref="transactionsList"></transactions-list>
    <turn-details ref="turnDetails"></turn-details>
    <expense-details ref="expenseDetails"></expense-details>
    <inventory-details ref="inventoryDetails"></inventory-details>
    <pending-payment-details ref="pendingPaymentDetails"></pending-payment-details>
    <iap-details ref="iapDetails"></iap-details>
    <invoice-details ref="invoiceDetails"></invoice-details>

</div>
</template>
<script>
export default {
    props: {
        entries: {
            type: Array,
            default: () => []
        },
        cssClass: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            modalTransactionEdit: null
        }
    },
    watch: {
        modalTransactionEdit(val) {
            if (!val) return;
            this.$nextTick(() => this.initCollapse());
        }
    },
    methods: {
        initCollapse() {

            function handleCollapseClick(e) {
                const button = e.target.closest('.collapse-toggle');
                if (!button) return;

                const targetId = button.getAttribute('data-target');
                if (!targetId) return;

                const container = document.getElementById(targetId);
                if (!container) return;

                const wrapper = button.closest('.log-changes-wrapper');
                const isCollapsed = container.classList.contains('collapsed');

                if (isCollapsed) {
                    container.classList.remove('collapsed');
                    button.setAttribute('aria-expanded', 'true');
                } else {
                    container.classList.add('collapsed');
                    button.setAttribute('aria-expanded', 'false');
                }

                if (wrapper) {
                    updateToggleButton(wrapper, areAllCollapsed(wrapper));
                }
            }

            function collapseAll(wrapper) {
                const containers = wrapper.querySelectorAll('.collapsible-nested:not(.collapsed)');
                containers.forEach(function(container) {
                    container.classList.add('collapsed');
                    const button = wrapper.querySelector('[data-target="' + container.id + '"]');
                    if (button) button.setAttribute('aria-expanded', 'false');
                });
                updateToggleButton(wrapper, true);
            }

            function expandAll(wrapper) {
                const containers = wrapper.querySelectorAll('.collapsible-nested.collapsed');
                containers.forEach(function(container) {
                    container.classList.remove('collapsed');
                    const button = wrapper.querySelector('[data-target="' + container.id + '"]');
                    if (button) button.setAttribute('aria-expanded', 'true');
                });
                updateToggleButton(wrapper, false);
            }

            function areAllCollapsed(wrapper) {
                const containers = wrapper.querySelectorAll('.collapsible-nested');
                if (containers.length === 0) return false;
                const collapsed = wrapper.querySelectorAll('.collapsible-nested.collapsed');
                return collapsed.length === containers.length;
            }

            function updateToggleButton(wrapper, allCollapsed) {
                const toggleBtn = document.getElementById('button-collapse');
                if (toggleBtn) toggleBtn.textContent = allCollapsed ? 'Mostrar todo' : 'Ocultar todo';
            }

            function handleToggleClick(e) {
                const button = document.getElementById('button-collapse');
                if (!button) return;
                e.preventDefault();

                const wrappers = document.querySelectorAll('.log-changes-wrapper');
                if (!wrappers.length) return;

                const wrapper = wrappers[wrappers.length - 1];

                const allCollapsed = areAllCollapsed(wrapper);
                if (allCollapsed) expandAll(wrapper);
                else collapseAll(wrapper);

                updateToggleButton(wrapper, areAllCollapsed(wrapper));
            }


            function initCollapse() {
                // Ocultar boton en caso de que no venga la tabla en el html 
                const toggleBtn = document.getElementById('button-collapse');
                const wrappersAll = document.querySelectorAll('.log-changes-wrapper');
                const hasTable = [...wrappersAll].some(w => w.querySelector('table'));
                if (!hasTable) {
                    if (toggleBtn) toggleBtn.style.display = 'none';
                    return;
                }
                if (toggleBtn) toggleBtn.style.display = '';

                const wrappers = document.querySelectorAll('.log-changes-wrapper:not([data-collapse-initialized])');

                wrappers.forEach(function(wrapper) {
                    wrapper.setAttribute('data-collapse-initialized', 'true');
                    wrapper.addEventListener('click', handleCollapseClick);

                    const toggleBtn = document.getElementById('button-collapse');
                    if (toggleBtn && !toggleBtn.hasAttribute('data-toggle-initialized')) {
                        toggleBtn.setAttribute('data-toggle-initialized', 'true');
                        toggleBtn.addEventListener('click', handleToggleClick);
                    }
                    updateToggleButton(wrapper, areAllCollapsed(wrapper));
                }
                );
            }
            initCollapse();
        },
        OpenHistory(log, returnBool = false) {
            if(log.type.indexOf('TRANSACTION') >= 0)
                return returnBool ? true : this.$refs.transactionDetails.Open(log.id_reference);
            if(log.type.indexOf('TURN') >= 0)
                return returnBool ? true : this.$refs.turnDetails.Open(log.id_reference);
            if(log.type.indexOf('INVOICE') >= 0)
                return returnBool ? true : this.$refs.invoiceDetails.Open(log.id_reference, log.type.indexOf('INVOICE_COMPLETED') > -1 );
            if(log.type.indexOf('EXPENSE') >= 0)
                return returnBool ? true : this.$refs.expenseDetails.Open(log.id_reference);
            if(log.type.indexOf('INVENTORY') >= 0)
                return returnBool ? true : this.$refs.inventoryDetails.Open(log.id_reference);
            if(log.type.indexOf('PENDING_PAYMENT') >= 0)
                return returnBool ? true : this.$refs.pendingPaymentDetails.Open(log.id_reference);
            if(log.type.indexOf('BOLETA') >= 0)
                return returnBool ? true : this.$refs.transactionDetails.Open(log.id_reference);
            if(log.type.indexOf('IAP') >= 0)
                return returnBool ? true : this.$refs.iapDetails.Open(log.id_reference);
            if(log.type.indexOf('SCHEDULED') >= 0)
                return returnBool ? true : this.$refs.iapDetails.Open(log.id_reference);
            if(log.id_reference)
                return returnBool ? true : this.GetlogDetails(log.id_reference);
            return null;
        },
        GetlogDetails(id_reference)  {
            this.modalTransactionEdit = null;
            this.Loading();
            axios.get(`/local/${this.Local.id}/log/details/${id_reference}`).then(res => {
                if(!res.data.data){
                    this.Response(res);
                    this.Info('No hay detalles para mostrar');
                    return;
                }
                this.modalTransactionEdit = res.data.data;
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });;
        }
    }
}
</script>
<style>
    .log-changes-wrapper .table-scroll-container {
        max-height: calc(100vh - 250px);
        overflow-y: auto;
        overflow-x: auto;
        border: 1px solid rgba(128, 128, 128, 0.2);
        border-radius: 4px;
        margin-bottom: 20px;
    }
    @media (max-width: 768px) {
        .log-changes-wrapper .table-scroll-container {
            max-height: calc(100vh - 200px);
        }
    }
    .log-changes-wrapper table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 0;
        font-weight: normal;
        table-layout: auto;
    }
    .log-changes-wrapper thead {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: #fff;
    }
    .log-changes-wrapper th,
    .log-changes-wrapper td {
        border: 1px solid rgba(128, 128, 128, 0.2);
        padding: 8px;
        vertical-align: top;
        word-wrap: break-word;
        overflow-wrap: break-word;
        margin: 0;
    }
    .log-changes-wrapper th {
        background-color: #f8f9fa;
        font-weight: 600;
        border-bottom: 2px solid rgba(128, 128, 128, 0.3);
    }
    .log-changes-wrapper th:first-child,
    .log-changes-wrapper td:first-child {
        width: 25%;
    }
    .log-changes-wrapper th:last-child,
    .log-changes-wrapper td:last-child {
        width: 75%;
    }

    .log-changes-wrapper .text-green { color: #28a745; }
    .log-changes-wrapper .text-red { color: #dc3545; }
    .log-changes-wrapper .text-muted { color: #888; font-style: italic; }
    .log-changes-wrapper .text-empty { color: #ccc; font-style: italic; }

    .log-changes-wrapper .nested-value {
        padding: 8px;
        border-radius: 4px;
        margin-top: 4px;
        font-size: 0.9em;
    }
    .log-changes-wrapper .nested-item {
        display: flex;
        gap: 5px;
        margin: 4px 0;
        line-height: 1.5;
    }
    .log-changes-wrapper .nested-level-0 { margin-left: 0; }
    .log-changes-wrapper .nested-level-nested { margin-left: 15px; border-left: 2px solid #ccc; padding-left: 10px; }

    .log-changes-wrapper .collapsible-nested {
        position: relative;
    }
    .log-changes-wrapper .collapse-toggle {
        background: none;
        border: none;
        cursor: pointer;
        padding: 4px 8px;
        margin-bottom: 8px;
        vertical-align: middle;
        font-size: 0.95em;
        color: #333;
        line-height: 1.4;
        display: inline-flex;
        align-items: center;
        gap: 6px;
        max-width: 100%;
        text-align: left;
        transition: background-color 0.2s ease;
    }
    .log-changes-wrapper .collapse-toggle:hover {
        color: #000;
        background-color: rgba(0, 0, 0, 0.05);
        border-radius: 3px;
    }
    .log-changes-wrapper .collapse-icon {
        display: inline-block;
        transition: transform 0.2s ease;
        user-select: none;
        flex-shrink: 0;
        font-size: 0.85em;
        color: #666;
    }
    .log-changes-wrapper .collapse-title {
        user-select: none;
        flex: 1;
        font-weight: 600;
        color: #333;
        opacity: 0.8;
    }
    .log-changes-wrapper .collapsible-nested.collapsed .collapse-icon {
        transform: rotate(-90deg);
    }
    .log-changes-wrapper .collapsible-content {
        display: block;
    }
    .log-changes-wrapper .collapsible-nested.collapsed .collapsible-content {
        display: none;
    }

    .log-changes-wrapper .change-comparison {
        margin-top: 6px;
        padding-left: 10px;
    }
    .log-changes-wrapper .change-comparison > div { margin: 4px 0; }

    .log-changes-wrapper .field-label { font-weight: 500; color: inherit; opacity: 0.7; }
    .log-changes-wrapper .old-value-label,
    .log-changes-wrapper .new-value-label { font-weight: 500; font-size: 0.9em; }
    .log-changes-wrapper .old-value-label { color: #dc3545; }
    .log-changes-wrapper .new-value-label { color: #28a745; }
    .log-changes-wrapper .old-value-modified { color: inherit; margin-right: 5px; }
    .log-changes-wrapper .new-value-modified { color: #ff9800; }
    .log-changes-wrapper .text-added-value { color: #28a745; }
    .log-changes-wrapper .text-deleted-value { color: #dc3545; }
    .log-changes-wrapper .text-modified-value { color: #ff9800; }
    .log-changes-wrapper .text-neutral { color: #888; }
    .log-changes-wrapper .color-box {
        display: inline-block;
        width: 40px;
        height: 16px;
        border: 1px solid #ccc;
        border-radius: 4px;
        vertical-align: middle;
        margin-right: 5px;
    }
    .log-changes-wrapper .change-image {
        max-width: 150px;
        max-height: 150px;
        border-radius: 4px;
        border: 1px solid #ddd;
        margin: 2px;
        vertical-align: middle;
    }

    .log-changes-wrapper .no-changes-message {
        padding: 20px;
        text-align: center;
        border: 1px solid #888;
        border-radius: 4px;
        margin: 20px 0;
        color: #888;
    }
    .log-changes-wrapper .no-changes-message p { margin: 0; }

    /* Modo oscuro */
    .dark .log-changes-wrapper .table-scroll-container {
        border-color: rgba(255, 255, 255, 0.1);
    }
    .dark .log-changes-wrapper thead {
        background-color: #1a1a1a;
    }
    .dark .log-changes-wrapper th {
        background-color: #2a2a2a;
        border-bottom-color: rgba(255, 255, 255, 0.2);
    }
    .dark .log-changes-wrapper th,
    .dark .log-changes-wrapper td {
        border-color: rgba(255, 255, 255, 0.1);
    }

    .dark .log-changes-wrapper .text-muted { color: #aaa; }
    .dark .log-changes-wrapper .text-empty { color: #666; }

    .dark .log-changes-wrapper .nested-level-nested {
        border-left-color: rgba(255, 255, 255, 0.2);
    }

    .dark .log-changes-wrapper .collapse-toggle { color: #e0e0e0; }
    .dark .log-changes-wrapper .collapse-toggle:hover {
        color: #fff;
        background-color: rgba(255, 255, 255, 0.1);
    }
    .dark .log-changes-wrapper .collapse-icon { color: #b0b0b0; }
    .dark .log-changes-wrapper .collapse-title {
        color: #e0e0e0;
        opacity: 0.9;
    }

    .dark .log-changes-wrapper .field-label {
        color: #d0d0d0;
        opacity: 0.8;
    }

    .dark .log-changes-wrapper .old-value-label { color: #ff6b6b; }
    .dark .log-changes-wrapper .new-value-label { color: #51cf66; }

    .dark .log-changes-wrapper .old-value-modified { color: #ff6b6b; }
    .dark .log-changes-wrapper .new-value-modified { color: #ffa94d; }

    .dark .log-changes-wrapper .text-added-value { color: #51cf66; }
    .dark .log-changes-wrapper .text-deleted-value { color: #ff6b6b; }
    .dark .log-changes-wrapper .text-modified-value { color: #ffa94d; }

    .dark .log-changes-wrapper .color-box { border-color: rgba(255, 255, 255, 0.3); }
    .dark .log-changes-wrapper .change-image { border-color: rgba(255, 255, 255, 0.2); }

    .dark .log-changes-wrapper .no-changes-message {
        border-color: rgba(255, 255, 255, 0.2);
        color: #aaa;
    }

    .dark .log-changes-wrapper .collapse-controls button {
        background-color: rgba(255, 255, 255, 0.1);
        color: #e0e0e0;
        border-color: rgba(255, 255, 255, 0.2);
    }
    .dark .log-changes-wrapper .collapse-controls button:hover {
        background-color: rgba(255, 255, 255, 0.15);
        border-color: rgba(255, 255, 255, 0.3);
    }
    .dark .log-changes-wrapper .collapse-controls button:active {
        background-color: rgba(255, 255, 255, 0.2);
    }
</style>